import { render, staticRenderFns } from "./send-to-gain-modal.vue?vue&type=template&id=274abd13&scoped=true&"
import script from "./send-to-gain-modal.js?vue&type=script&lang=js&"
export * from "./send-to-gain-modal.js?vue&type=script&lang=js&"
import style0 from "./send-to-gain-modal.scss?vue&type=style&index=0&id=274abd13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274abd13",
  null
  
)

export default component.exports